import React from 'react';
import { connect } from 'react-redux';
import { history } from '../store';
import '../styles/ManualsView.css';

const MANUAL_META = {
  Cash:                 { icon: 'fa-cash-register',    desc: 'Gestión de efectivo y arqueos' },
  Incidences:           { icon: 'fa-exclamation-triangle', desc: 'Registro y resolución de incidencias' },
  Management:           { icon: 'fa-cogs',               desc: 'Administración general del sistema' },
  TechnicalRequirements:{ icon: 'fa-clipboard-list',     desc: 'Requisitos técnicos de instalación' },
  TroubleShooting:      { icon: 'fa-tools',              desc: 'Resolución de problemas comunes' },
  User:                 { icon: 'fa-user-circle',        desc: 'Guía de uso para operadores' },
  TechnicalSpecs:       { icon: 'fa-microchip',          desc: 'Especificaciones técnicas del hardware' },
};

class ManualsView extends React.Component {
  constructor(props) {
    super(props);
    this.manuals = [
      'Cash',
      'Incidences',
      'Management',
      'TechnicalRequirements',
      'TroubleShooting',
      'User',
      'TechnicalSpecs',
    ];
  }

  goTo(id, e) {
    history.push(`/manuals/${id}`);
  }

  render() {
    return (
      <div className="manuals-view">
        {/* Header */}
        <div className="mn-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-book mr-3"></i>
                MANUALES
              </h1>
            </div>
          </div>
        </div>

        {/* Card Grid */}
        <div className="manuals-grid">
          {this.manuals.map((name) => {
            const label = name.replace(/([A-Z])/g, ' $1').trim();
            const meta = MANUAL_META[name] || { icon: 'fa-file-pdf', desc: '', gradient: 'linear-gradient(135deg,#6b7280,#4b5563)', accent: '#6b7280' };

            return (
              <div key={name} className="manual-card">
                <div className="manual-card-body">
                  <div className="manual-card-header">
                    <div className="manual-card-icon-wrap">
                      <i className={`fas ${meta.icon}`}></i>
                    </div>
                    <div>
                      <p className="manual-card-title">{label}</p>
                      <p className="manual-card-desc">{meta.desc}</p>
                    </div>
                  </div>
                  <div className="manual-card-langs">
                    <button
                      className="manual-card-btn"
                      onClick={() => this.goTo(`Manual${name}_es`)}
                      title={`${label} — Español`}
                    >
                      <span>🇪🇸</span>
                      <span>Español</span>
                    </button>
                    <button
                      className="manual-card-btn"
                      onClick={() => this.goTo(`Manual${name}_en`)}
                      title={`${label} — English`}
                    >
                      <span>🇬🇧</span>
                      <span>English</span>
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  error: state.audits.error,
  loading: state.audits.loading,
  form: state.form,
});

export default connect(mapStateToProps)(ManualsView);
